import { IBaseWidget } from '../../../IBaseWidget';
import {
  ISortableWidgetData,
  Widget,
  WidgetMainType,
  WidgetOrRoot,
  WidgetType,
} from '../../../Widget';

export interface IRootWidget
  extends Omit<IBaseWidget, 'id' | 'path' | 'order'> {
  /** Numero di versione della migrazione */
  versionId?: number;
  type: WidgetType.Root;
  mainType: WidgetMainType.Root;
  children: Widget[];
}

export function isRoot(widget: WidgetOrRoot | null): widget is IRootWidget {
  if (!widget) return false;
  return widget.type === WidgetType.Root;
}

/**
 * Ritorna vero se i dati del widget forniti si riferiscono
 * a un widget di tipo container
 */
export function isRootData(data: ISortableWidgetData | undefined) {
  if (!data) return false;
  return data.type === WidgetType.Root;
}
